var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1689_29193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.706 6.33368C11.8902 6.12794 11.8727 5.81184 11.667 5.62765C11.4613 5.44345 11.1452 5.46091 10.961 5.66665L8.71486 8.17544C8.25973 8.68379 7.95323 9.02435 7.69118 9.2446C7.44154 9.45442 7.29492 9.50016 7.16683 9.50016C7.03874 9.50016 6.89212 9.45442 6.64248 9.2446C6.38043 9.02434 6.07393 8.68379 5.61879 8.17543L5.03935 7.52822C4.85515 7.32249 4.53905 7.30503 4.33332 7.48922C4.12758 7.67342 4.11012 7.98952 4.29431 8.19525L4.89851 8.8701C5.32241 9.34361 5.67599 9.73857 5.99906 10.0101C6.34082 10.2974 6.70945 10.5002 7.16683 10.5002C7.62421 10.5002 7.99284 10.2974 8.33459 10.0101C8.65766 9.73858 9.01123 9.34363 9.43512 8.87014L11.706 6.33368Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496ZM1.8335 8.00016C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1689_29193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/TickCircle.b82ed1c5c2a4fc2a46b5aacd0b861591.svg";
export { ForwardRef as ReactComponent };